import React from 'react';
import { Box, Button, IconButton } from '@mui/material';
import { 
  Add as AddIcon, 
  Settings as SettingsIcon,
  Search as SearchIcon
} from '@mui/icons-material';
import SectionHeader from './SectionHeader';

/**
 * Demo component to showcase different variations of the SectionHeader component
 */
const SectionHeaderDemo = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px', width: '100%' }}>
      {/* Basic usage with just a title */}
      <Box>
        <h3>Basic SectionHeader</h3>
        <SectionHeader 
          title="Intake Agent" 
          subtitle="2.0 Flash"
        />
      </Box>

      {/* With expand icon */}
      <Box>
        <h3>With Expand Icon</h3>
        <SectionHeader 
          title="Intake Agent" 
          subtitle="2.0 Flash"
          showExpandIcon={true}
        />
      </Box>

      {/* With custom action buttons */}
      <Box>
        <h3>With Custom Action Buttons</h3>
        <SectionHeader 
          title="Custom Actions" 
          subtitle="Showing custom action buttons"
          showUploadButton={false}
          showMoreButton={false}
          rightContent={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <IconButton
                sx={{
                  width: '32px',
                  height: '32px',
                  padding: '6px 8px',
                  borderRadius: '8px',
                  color: '#465366',
                  '&:hover': {
                    bgcolor: 'rgba(0, 0, 0, 0.04)',
                  },
                }}
              >
                <SearchIcon sx={{ fontSize: '18px' }} />
              </IconButton>
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                sx={{
                  backgroundColor: '#3B82F6',
                  '&:hover': {
                    backgroundColor: '#2563EB',
                  },
                  color: 'white',
                  textTransform: 'none',
                  borderRadius: '8px',
                  padding: '6px 12px',
                }}
              >
                Add New
              </Button>
            </Box>
          }
        />
      </Box>

      {/* With custom left content */}
      <Box>
        <h3>With Custom Left Content</h3>
        <SectionHeader 
          title="With Icon" 
          subtitle="Showing custom left content"
          leftContent={
            <IconButton
              sx={{
                width: '32px',
                height: '32px',
                padding: '6px 8px',
                borderRadius: '8px',
                color: '#465366',
                bgcolor: 'rgba(0, 0, 0, 0.04)',
                '&:hover': {
                  bgcolor: 'rgba(0, 0, 0, 0.08)',
                },
              }}
            >
              <SettingsIcon sx={{ fontSize: '18px' }} />
            </IconButton>
          }
        />
      </Box>

      {/* With click handlers */}
      <Box>
        <h3>With Click Handlers</h3>
        <SectionHeader 
          title="Interactive" 
          subtitle="With click handlers"
          onUploadClick={() => alert('Upload button clicked')}
          onMoreClick={() => alert('More button clicked')}
        />
      </Box>
    </Box>
  );
};

export default SectionHeaderDemo;
